export default "__VITE_ASSET__C22232Da__"